module.exports = __webpack_public_path__ + "static/media/ban-page-tips.1fb61e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-page-tips.png
// module id = 1939
// module chunks = 6